module.exports = __webpack_public_path__ + "img/messagePic.e167b0a8.png";